import React, { Component } from 'react'
import { connect } from 'react-redux'
import injectSagas from 'helpers/injectSagas'
import { withRouter } from 'react-router'
import { compose } from 'recompose'

import { Tab } from 'react-toolbox/lib/tabs'

import Tabs from './Tabs'
import loadSagas from '../Project/Specifications/sagas'

import ProjectExecutionTab from './Tabs/ProjectExecutionTab'
import ScheduleTab from './Tabs/ScheduleTab'
import LifecycleTab from './Tabs/LifecycleTab'
import WeeklyUpdatesTab from './Tabs/WeeklyUpdatesTab'

import clickNotify from 'containers/App/Notification/ClickNotify'

import { warning }  from 'containers/App/Notification/actions'

import {
    toggleNotify
} from './actions'

import {
    scheduleInfoForSelectedProjectSelector,
    toggleNotifySelector
} from './selectors'

// const NotifyHoc = clickNotify(Tabs)

const mapStateToProps = (state) => {
    return {
        scheduleInfo: scheduleInfoForSelectedProjectSelector(state),
        toggleNotify: toggleNotifySelector(state)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        warningNote: (message) => dispatch(warning(message)),
        toggleNotifyAction: (toggle) => dispatch(toggleNotify(toggle))
    }
}

class Forms extends Component {
    constructor(props) {
        super(props)

        this.state = {
            formIndex: 0
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.selectedProjects.length > 1) {
            if(this.state.formIndex === 1) {
                this.setState({
                    formIndex: 2
                })
            }
        }
    }
    onFormChange = (index) => {
        if (this.props.toggleNotify) {
            this.props.warningNote('Previous Form Data is cleared when switching tabs')
            this.props.toggleNotifyAction(false)
        }
        this.setState({ formIndex: index })
    }
    checkForm = (check) => this.setState({ anyFormDetails: check })
    render() {
        const {
            selectedProjects,
            scheduleInfo,
        } = this.props
        let preloadedInfo = {}
        if (scheduleInfo) {
            Object.entries(scheduleInfo).forEach((field) => {
                if (field[1].length === 10) {
                    preloadedInfo = {
                        ...preloadedInfo,
                        [field[0]]: field[1]
                    }
                }
            })
        }

        return (
            <Tabs
                index={this.state.formIndex}
                onChange={this.onFormChange}
            >
                <Tab label={"Project Execution"}>
                    <ProjectExecutionTab
                        numberOfProjects={selectedProjects.length}
                    />
                </Tab>
                <Tab label={"Schedule"} disabled={selectedProjects.length > 1}>
                    <ScheduleTab
                        scheduleInfo={preloadedInfo}
                    />
                </Tab>
                <Tab label={"Lifecycle"}>
                    <LifecycleTab 
                        numberOfProjects={selectedProjects.length}
                    />
                </Tab>
                <Tab label={"Weekly Updates"}>
                    <WeeklyUpdatesTab 
                        numberOfProjects={selectedProjects.length}
                    />
                </Tab>
            </Tabs>
        )
    }
}

const withSagas = injectSagas({ "Forms": loadSagas })
export default compose(
    withRouter,
    withSagas,
    connect(mapStateToProps, mapDispatchToProps)
)(Forms)